import { Link } from "react-router-dom";
import { GUIDES } from "../data/guides";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-line bg-bg-alt mt-24"
    >
      <div className="container-x py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <p className="font-display text-2xl font-semibold tracking-tight">
            UpgradeCost
          </p>
          <p className="mt-3 text-ink-muted text-sm max-w-sm">
            A practical planning tool for homeowners. Get a clear cost range,
            spot the hidden expenses, and bring a real brief to every contractor
            bid.
          </p>
        </div>

        <div>
          <p className="overline mb-4">Tool</p>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/calculator" className="text-ink hover:text-brand">
                Cost calculator
              </Link>
            </li>
            <li>
              <Link to="/guides" className="text-ink hover:text-brand">
                All cost guides
              </Link>
            </li>
            <li>
              <Link to="/quote" className="text-ink hover:text-brand">
                Get local quotes
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <p className="overline mb-4">Popular guides</p>
          <ul className="space-y-2 text-sm">
            {GUIDES.slice(0, 5).map((g) => (
              <li key={g.slug}>
                <Link
                  to={`/guides/${g.slug}`}
                  className="text-ink-muted hover:text-ink"
                >
                  {g.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-line">
        <div className="container-x py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-ink-muted">
          <p>© {new Date().getFullYear()} UpgradeCost. All estimates are guidance, not bids.</p>
          <p>Made for U.S. homeowners planning a remodel.</p>
        </div>
      </div>
    </footer>
  );
}
